import {
  Directions,
  TableColumnStyle,
  centerActivityStatusEnum,
  eventConstants,
  getRoleById,
  modeConstants,
  timezoneConstants,
  translationConstants,
} from "../../../../constants";
import i18next from "i18next";
import {
  copyToClipboard,
  formatExpiry,
  formatUnixTime,
  serverFormatToDateString,
} from "../../../../system";
import refundIcon from "../../../../assets/images/icon/refund.svg";
import Tooltip from "@mui/material/Tooltip";
import removeInstructorIcon from "../../../../assets/images/icon/remove_instructor_icon.svg";

const isEventExpired = (endDate) => {
  const currentUnixTime = Math.floor(Date.now() / 1000);
  const eventEndUnixTime = endDate;

  return eventEndUnixTime > currentUnixTime;
};

export const getcolumns = (
  t,
  getRowData,
  setMode,
  showEditIcon,
  onDelete,
  direction,
  onUpdate,
  onView,
  cities
) => [
  {
    id: "eventInfo.id",
    accessor: "eventInfo.id",
    name: t(translationConstants.RECORD_ID),
    cell: (row) => (
      <Tooltip
        title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
        placement="top"
        arrow
      >
        <div
          className="truncate-text cursor-pointer"
          onClick={() => copyToClipboard(row.eventInfo.id)}
        >
          {row.eventInfo.id}
        </div>
      </Tooltip>
    ),
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "EventInfo.title",
    name: t(translationConstants.TITLE),
    selector: (row) =>
      direction === Directions.rtl
        ? row?.eventInfo?.arabicTitle || row?.eventInfo?.title
        : row?.eventInfo?.title,
    reorder: true,
    sortable: true,
    sortDirection: null,
  },
  {
    id: "EventInfo.isPublicRegistrationAllowed",
    name: t(translationConstants.TYPE),
    selector: (row) =>
      row?.eventInfo?.isPublicRegistrationAllowed
        ? t(translationConstants.PUBLIC)
        : t(translationConstants.PRIVATE),
    reorder: true,
    sortable: true,
    sortDirection: null,
  },

  {
    id: "EventInfo.spotInfo.spotName",
    name: t(translationConstants.LOCATION),
    selector: (row) => row.eventInfo?.Lat,
    sortDirection: null,
    reorder: true,
    sortable: true,
    cell: (row) => {
      const city = cities?.find((s) => s.id === row.eventInfo?.cityId);
      return (
        <div>
          {city
            ? direction === Directions.rtl
              ? city?.arabicName || city?.name
              : city?.name
            : direction === Directions.rtl
            ? row.eventInfo?.spotInfo?.arabicSpotName ||
              row.eventInfo?.spotInfo?.spotName
            : row.eventInfo?.spotInfo?.spotName}
        </div>
      );
    },
  },

  {
    id: "EventInfo.startDate",
    name: t(translationConstants.CENTER_START_DATE),
    selector: (row) => row.eventInfo?.startDate,
    reorder: true,
    sortable: true,
    sortDirection: null,
    cell: (row) => (
      <div>
        {serverFormatToDateString(
          row.eventInfo?.startDateString,
          timezoneConstants.dayMonthYearFormat
        )}
      </div>
    ),
  },
  {
    id: "EventInfo.endDate",
    name: t(translationConstants.CENTER_END_DATE),
    selector: (row) => row.eventInfo?.endDate,
    reorder: true,
    sortable: true,
    sortDirection: null,
    cell: (row) => (
      <div>
        {serverFormatToDateString(
          row.eventInfo?.endDateString,
          timezoneConstants.dayMonthYearFormat
        )}
      </div>
    ),
  },
  {
    id: "EventInfo.startTime",
    name: t(translationConstants.CENTER_START_TIME),
    selector: (row) => row.eventInfo?.startTime,
    sortDirection: null,
    cell: (row) => (
      <div>
        {serverFormatToDateString(
          row.eventInfo?.startDateString,
          timezoneConstants.hourMinuteFormat
        )}
      </div>
    ),
  },
  {
    id: "EventInfo.endTime",
    name: t(translationConstants.CENTER_END_TIME),
    selector: (row) => row.eventInfo?.endTime,
    sortDirection: null,
    cell: (row) => (
      <div>
        {serverFormatToDateString(
          row.eventInfo?.endDateString,
          timezoneConstants.hourMinuteFormat
        )}
      </div>
    ),
  },
  {
    id: "EventInfo.maximumParticipantsAllowed",
    name: t(translationConstants.maximum_participants),
    selector: (row) => row.eventInfo?.maximumParticipantsAllowed,
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: "150px",
    cell: (row) => <div>{row.eventInfo?.maximumParticipantsAllowed}</div>,
  },
  {
    id: "EventInfo.status",
    name: t(translationConstants.STATUS),
    reorder: true,
    sortable: true,
    sortDirection: null,
    selector: (row) => {
      const statusMap = Object.keys(centerActivityStatusEnum).reduce(
        (acc, key) => {
          acc[centerActivityStatusEnum[key]] = t(translationConstants[key]);
          return acc;
        },
        {}
      );
      return statusMap[row?.eventInfo?.status];
    },
    minWidth: "130px",
  },
  {
    id: "actions",
    name: t(translationConstants.Actions),
    cell: (row) => (
      <>
        {row.eventInfo?.status !== centerActivityStatusEnum.DRAFT && (
          <svg
            onClick={() => {
              getRowData(row);
              setMode(modeConstants.VIEW_MODE);
              onView(row.eventInfo.id);
            }}
            width="20"
            height="20"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.1685 8.99922C16.1685 8.99922 14.0341 13.268 9.05391 13.268C4.07371 13.268 1.93933 8.99922 1.93933 8.99922C1.93933 8.99922 4.07371 4.73047 9.05391 4.73047C14.0341 4.73047 16.1685 8.99922 16.1685 8.99922Z"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
            <circle
              cx="9.05381"
              cy="8.99766"
              r="2.13438"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
          </svg>
        )}
        {showEditIcon && isEventExpired(row.eventInfo?.endDate) && (
          <svg
            onClick={() => {
              setMode(modeConstants.EDIT_MODE);
              getRowData(row);
              onUpdate(row.eventInfo.id);
            }}
            width="20"
            height="20"
            viewBox="20 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.4449 13.2687V9.53359H35.3778V13.2687H26.8403V4.73125H30.5754V3.66406H26.8403C26.2509 3.66406 25.7731 4.14186 25.7731 4.73125V13.2687C25.7731 13.8581 26.2509 14.3359 26.8403 14.3359H35.3778C35.9671 14.3359 36.4449 13.8581 36.4449 13.2687ZM34.9392 4.05008C34.6946 3.80355 34.3597 3.66406 34.0103 3.66406C33.6614 3.66406 33.3268 3.80324 33.0808 4.05072L28.6153 8.51625C28.2162 8.86785 27.9546 9.39104 27.9092 9.95369L27.9074 11.6692V12.2028H30.1136C30.7189 12.1613 31.2472 11.8971 31.6199 11.4672L36.0602 7.02882C36.3066 6.78247 36.445 6.44835 36.445 6.09996C36.445 5.75157 36.3066 5.41745 36.0602 5.1711L34.9392 4.05008ZM30.076 11.1359C30.3611 11.1157 30.6264 10.9831 30.8395 10.7393L34.075 7.50381L32.6054 6.03405L29.3461 9.29222C29.1299 9.48342 28.9962 9.75092 28.9747 9.99562V11.1349L30.076 11.1359ZM33.3601 5.27956L34.8296 6.7492L35.3057 6.27316C35.3519 6.22695 35.3778 6.16427 35.3778 6.09892C35.3778 6.03357 35.3519 5.97089 35.3057 5.92468L34.1832 4.80217C34.1375 4.75611 34.0753 4.73021 34.0104 4.73021C33.9455 4.73021 33.8833 4.75611 33.8376 4.80217L33.3601 5.27956Z"
              fill="#2C7465"
            />
          </svg>
        )}
        <svg
          onClick={() => {
            onDelete(translationConstants.DELETE_A_USER, row);
          }}
          width="20"
          height="20"
          viewBox={direction === Directions.rtl ? "40 0 20 16" : "40 0 20 16"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ overflow: "hidden" }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.7769 2.47656H52.3342C52.9891 2.47656 53.5199 3.00745 53.5199 3.66233V4.25521H55.2987C55.9536 4.25521 56.4845 4.78609 56.4845 5.44097V6.62674C56.4845 7.28162 55.9536 7.8125 55.2987 7.8125H55.2512L54.7059 14.3344C54.7059 14.9893 54.175 15.5201 53.5201 15.5201H47.5913C46.9364 15.5201 46.4055 14.9893 46.4076 14.3836L45.86 7.8125H45.8126C45.1577 7.8125 44.6268 7.28162 44.6268 6.62674V5.44097C44.6268 4.78609 45.1577 4.25521 45.8126 4.25521H47.5911V3.66233C47.5911 3.00745 48.122 2.47656 48.7769 2.47656ZM47.5911 5.44097V5.44092H45.8126V6.62668H55.2987V5.44092H53.5199V5.44097H47.5911ZM47.5913 14.3344L47.0497 7.81268H54.0615L53.5222 14.2851L53.5201 14.3344H47.5913ZM52.3345 3.66243V4.25532H48.7772V3.66243H52.3345Z"
            fill="#FF0000"
          />
        </svg>
      </>
    ),
  },
];
export const getParticipantColumns = (
  t,
  getRowData,
  setMode,
  showEditIcon,
  eventInfo,
  setRefundShow,
  setRowData,
  onCancelRegistration,
  noFeeCancellation
) => {
  const columns = [
    {
      id: "id",
      accessor: "id",
      name: t(translationConstants.RECORD_ID),
      cell: (row) => (
        <Tooltip
          title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
          placement="top"
          arrow
        >
          <div
            className="truncate-text cursor-pointer"
            onClick={() => copyToClipboard(row.id)}
          >
            {row.id}
          </div>
        </Tooltip>
      ),
      reorder: true,
      sortable: true,
      sortDirection: null,
      minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
    },
    {
      id: "name",
      name: t(translationConstants.name),
      selector: (row) => row?.englishFirstName,
      reorder: true,
      sortable: true,
      sortDirection: null,
      cell: (row) => (
        <div>
          {row?.englishFirstName} {row?.englishLastName}
        </div>
      ),
    },
    {
      id: "email",
      name: t(translationConstants.Email),
      selector: (row) => row?.email,
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "gender",
      name: t(translationConstants.gender),
      selector: (row) => row?.gender,
      reorder: true,
      sortable: true,
      sortDirection: null,
      cell: (row) => {
        // Assuming 0 is Male, 1 is Female, and any other value is 'Other'
        return row?.gender === 0
          ? t(translationConstants.male)
          : row?.gender === 1
          ? t(translationConstants.female) // Corrected the typo here
          : t(translationConstants.other); // Changed from 'active' to 'other'
      },
    },
    {
      id: "nationality",
      name: t(translationConstants.nationality),
      selector: (row) => row?.nationality,
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "role",
      name: t(translationConstants.TYPE),
      selector: (row) => getRoleById(row?.role),
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "isMembershipHolder",
      name: t(translationConstants.isMember),
      selector: (row) => row?.isMembershipHolder,
      reorder: true,
      sortable: true,
      sortDirection: null,
      cell: (row) => (
        <div>{row.userInfo?.isMembershipHolder ? "Yes" : "No"}</div>
      ),
    },
  ];

  if (eventInfo?.isPublicRegistrationAllowed) {
    columns.push({
      id: "fee",
      name: t(translationConstants.fees),
      selector: (row) => row?.fee,
      reorder: true,
      sortable: true,
      sortDirection: null,
    });
  }

  columns.push({
    id: "actions",
    center: true,
    name: eventInfo?.isPublicRegistrationAllowed
      ? t(translationConstants.refund)
      : t(translationConstants.Actions),
    cell: (row) => (
      <>
        {row?.isActive ? (
          eventInfo?.isPublicRegistrationAllowed ? (
            <img
              onClick={() => {
                if (row?.fee) {
                  setRefundShow(true);
                  setRowData(row);
                } else {
                  noFeeCancellation(row);
                }
              }}
              className="cursor-pointer"
              src={refundIcon}
              alt="refund"
            />
          ) : (
            <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              onClick={() => {
                onCancelRegistration(
                  translationConstants.CANCEL_REGISTRATION,
                  row
                );
              }}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.5 17.252C4.94365 17.252 1.25 13.5583 1.25 9.00195C1.25 4.4456 4.94365 0.751953 9.5 0.751953C14.0563 0.751953 17.75 4.4456 17.75 9.00195C17.75 13.5583 14.0563 17.252 9.5 17.252ZM9.50004 15.7513C13.228 15.7513 16.25 12.7292 16.25 9.0013C16.25 5.27337 13.228 2.2513 9.50004 2.2513C5.77212 2.2513 2.75004 5.27337 2.75004 9.0013C2.75004 12.7292 5.77212 15.7513 9.50004 15.7513ZM7.03078 12.5325L9.50045 10.0628L11.9701 12.5325L13.0308 11.4718L10.5611 9.00212L13.0308 6.53245L11.9701 5.47179L9.50045 7.94146L7.03078 5.47179L5.97012 6.53245L8.43979 9.00212L5.97012 11.4718L7.03078 12.5325Z"
                fill="#FF0000"
              />
            </svg>
          )
        ) : eventInfo?.isPublicRegistrationAllowed ? (
          <span>{row.refundAmount}</span>
        ) : (
          <span>{t(translationConstants.CANCELLED)}</span>
        )}
      </>
    ),
  });

  return columns;
};
